<template>
    <el-dialog v-model="dialogVisible" :close-on-click-modal="false" :show-close="false" width="30%"
        :before-close="handleClose">
        <template #title>
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <span>{{ row ? 'Edit Smith' : 'Add Smith' }}</span>
                <div style="display: flex; align-items: center; gap: 6px;">
                    <el-button size="small" type="warning" @click="smithFormRef.resetFields()">Reset</el-button>
                </div>
            </div>
        </template>

        <SmithInfoForm ref="smithFormRef" :modelValue="form" :readonly="false" />

        <template #footer>
            <el-button @click="dialogVisible = false" size="small">Cancel</el-button>
            <el-button type="primary" @click="handleSubmit" size="small">Confirm</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { ElMessageBox } from 'element-plus'
import { useMutation } from '@/composables/useMutation'
import { registerSmith, updateSmith } from '@/api/smith'
import { defaultSmith } from '../../defaults'
import SmithInfoForm from './SmithInfoForm.vue'

const props = defineProps({
    visible: { type: Boolean, default: false },
    row: { type: Object, default: null },
})

const emit = defineEmits(['update:visible', 'saved'])

const dialogVisible = computed({
    get: () => props.visible,
    set: (val) => emit('update:visible', val),
})

const smithFormRef = ref(null)
const form = ref({ ...defaultSmith })

const { mutate } = useMutation({ useOverlay: true })

watch(() => props.visible, (val) => {
    if (val) {
        form.value = props.row ? { ...props.row } : { ...defaultSmith }
        nextTick(() => smithFormRef.value?.clearValidate())
    }
})

function handleClose() {
    smithFormRef.value?.resetFields()
    dialogVisible.value = false
}

async function handleSubmit() {
    const valid = await smithFormRef.value?.validate().catch(() => false)
    if (!valid) return

    ElMessageBox.confirm('Are you sure to submit this form?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
    }).then(() => {
        const isEdit = !!props.row
        mutate(
            () => isEdit ? updateSmith(form.value.id, form.value) : registerSmith(form.value),
            {
                success: isEdit ? 'Successfully updated!' : 'Successfully added!',
                onSuccess: () => {
                    dialogVisible.value = false
                    emit('saved')
                },
            }
        )
    }).catch(() => { })
}
</script>
